import { type FC, memo } from "react";
import { type DetailedOrderData } from "~/domains/orders/types/modelsV2";
import { type CaseDataObject } from "~/features/orders/orderDetails/components/ServiceCases/types";
import OrderLineListRow from "../../orderListV2/OrderLineListRow";
interface OrderTableProps {
  selected: number[];
  selectItem: (itemIndex: number) => void;
  selectable: boolean;
  orderDetailsData: DetailedOrderData;
  serviceCaseData?: Record<string, CaseDataObject[]>;
}

const OrderTableV2: FC<OrderTableProps> = ({ selectable, selected, selectItem, orderDetailsData, serviceCaseData }) => {
  const selectedMap = selected.reduce(
    (map, index) => {
      map[index] = true;
      return map;
    },
    {} as Record<number, boolean>,
  );

  return (
    <>
      {orderDetailsData.products.map((entry, index) => {
        const entrySelected = !!selectedMap[index];
        const canSelectRow = selectable && Boolean(entry.product?.url) && Boolean(entry.confirmedQty);
        const selectableIndexSet = selectable
          ? canSelectRow
            ? new Set<number>([index])
            : new Set<number>()
          : undefined;

        return (
          <OrderLineListRow
            key={index}
            data={entry}
            lineItemIndex={index}
            orderData={orderDetailsData}
            soNumber={orderDetailsData.soNumber}
            poNumber={orderDetailsData.poNumber}
            selectable={selectable}
            selectionDisabled={!selectable || !canSelectRow}
            selected={entrySelected}
            selectItem={selectItem}
            selectableIndexSet={selectableIndexSet}
            serviceCasesOverride={serviceCaseData?.[entry.lineNo]}
          />
        );
      })}
    </>
  );
};

export default memo(OrderTableV2);
